import { useEffect, useRef } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth';
import { communicationsService } from '@/services/communications.service';

export function CommunicationActivity() {
  const { user, isAuthenticated } = useAuthStore();
  if (!isAuthenticated || user?.role !== 'STUDENT') return null;
  return <RecordActivity key={user.id} />;
}

function RecordActivity() {
  const lastAttempt = useRef<number | null>(null);
  const activity = useMutation({
    mutationFn: communicationsService.activity,
    retry: false,
  });
  const record = activity.mutate;
  useEffect(() => {
    const interval = 5 * 60 * 1000;
    const touch = () => {
      if (document.visibilityState !== 'visible') return;
      if (
        lastAttempt.current !== null &&
        Date.now() - lastAttempt.current < interval
      )
        return;
      lastAttempt.current = Date.now();
      record();
    };
    touch();
    const timer = window.setInterval(touch, interval);
    document.addEventListener('visibilitychange', touch);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', touch);
    };
  }, [record]);
  return null;
}
